import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import BOMForm from "../../../../components/MainForm/BOMForm";
import ParentBomForm from "../../../../components/MainForm/ParentBomForm";
import SUBBOMForm from "../../../../components/MainForm/SUBBOMForm";
import ParentBomsService from "../../../../services/parentboms.service";
import ChildBomsService from "../../../../services/childboms.service";
import SubBomsService from "../../../../services/subboms.service";
import handleChangeWebsiteTab from "../../../../commons/ChangeWebsiteTab";

export default function EditBOMInformation() {
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const websiteTab = {
    key: state?.sub || state?.type || "Child",
    setWebsiteName,
    tabNames: {
      Parent: "แก้ไขชนิด BOM",
      Child: "แก้ไขรายละเอียด BOM",
      SubBom: "แก้ไขข้อมูล Sub BOM"
    }
  };

  const refreshPage = (path, state) => {
    navigate(path, { state: state });
    navigate(0);
  };

  const handleSubmitParentBoms = (id, data) => {
    delete data.Id;
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ParentBomsService.editParentBoms(id, data),
      navigated: (navi) =>
        navi && refreshPage(pathname, { type: "Bom", sub: "Parent" })
    });
  };

  const handleSubmitChildBoms = ({ data }) => {
    data?.Child?.Array.forEach((item, idx) => {
      const modifiedItem = (({ Id, ...rest }) => rest)({
        Id: item.Id,
        Parent_Bom_Id: item.Parent_Bom_Id,
        Item_Child_Id: Number(item.Item_Child_Id),
        Item_Child_Qty: Number(item.Item_Child_Qty),
        Foc_Id: item.Foc_Id,
        Bom_Pm: item.Bom_Pm,
        Sub_Bom: item.Sub_Bom
      });

      const serviceRequest = item.Id
        ? ChildBomsService.editChildBoms(item.Id, modifiedItem)
        : ChildBomsService.createChildBoms({ Array: [modifiedItem] });

      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest,
        navigated: (navi) =>
          navi &&
          idx === data?.Child?.Array.length - 1 &&
          refreshPage(pathname, { type: "Bom", sub: "Child" })
      });
    });
  };

  const handleSubmitSubBoms = ({ data }) => {
    data?.Array.forEach((item, idx) => {
      const modifiedItem = (({ Id, ...rest }) => rest)({
        Id: item.Id,
        Child_Bom_Id: item.Child_Bom_Id,
        Item_Child_Sub_Id: item.Item_Child_Sub_Id,
        Item_Child_Sub_Qty: item.Item_Child_Sub_Qty,
        Foc_Id: item.Foc_Id,
        Cus_Id: item.Cus_Id
      });

      const serviceRequest = item.Id
        ? SubBomsService.editSubBoms(item.Id, modifiedItem)
        : SubBomsService.createSubBoms({ Array: [modifiedItem] });

      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest,
        navigated: (navi) =>
          navi &&
          idx === data?.Array.length - 1 &&
          refreshPage(pathname, { type: "SubBom" })
      });
    });
  };

  useEffect(() => handleChangeWebsiteTab(websiteTab), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content={`Edit BOM Information Page`} />
      </Helmet>

      <Container fluid className={state?.sub ? "p-0" : "p-3"}>
        {state?.type === "Bom" ? (
          <Tabs
            justify
            defaultActiveKey={state?.sub || "Child"}
            onSelect={(key) => handleChangeWebsiteTab({ ...websiteTab, key })}
          >
            <Tab eventKey="Child" title="แก้ไขรายละเอียด BOM">
              {websiteName === "แก้ไขรายละเอียด BOM" && (
                <BOMForm
                  editData={{ type: "edit" }}
                  onSubmitCallback={handleSubmitChildBoms}
                />
              )}
            </Tab>
            <Tab eventKey="Parent" title="แก้ไขชนิด BOM">
              {websiteName === "แก้ไขชนิด BOM" && (
                <ParentBomForm onSubmitCallback={handleSubmitParentBoms} />
              )}
            </Tab>
          </Tabs>
        ) : (
          <SUBBOMForm
            editData={{ type: "edit" }}
            onSubmitCallback={handleSubmitSubBoms}
          />
        )}
      </Container>
    </>
  );
}
